const getProgressWidth = (type) => {
  switch (type) {
    case 'form':
      return '40%';
    case 'loading':
      return '80%';
    default:
      return '100%';
  }
};

export default getProgressWidth;
